import { render, staticRenderFns } from "./DeclarationCard.vue?vue&type=template&id=35d67540&"
import script from "./DeclarationCard.vue?vue&type=script&lang=js&"
export * from "./DeclarationCard.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports